export const checkInvoiceCorrection = (order) =>
	order._ticket?.find((ticket) => ticket.invoice?.correction_number);
